import { MovieStatus, TvStatus } from '@tmdb-graphql-api/schema/types';

export const statusHasMovieRibbon = (status: MovieStatus): status is Exclude<MovieStatus, 'RELEASED'> => {
  return [MovieStatus.InProduction, MovieStatus.Planned, MovieStatus.PostProduction, MovieStatus.Rumored].includes(
    status,
  );
};

export const statusHasTvRibbon = (status: TvStatus): status is Exclude<TvStatus, 'PILOT'> => {
  return [
    TvStatus.Canceled,
    TvStatus.Ended,
    TvStatus.InProduction,
    TvStatus.Planned,
    TvStatus.ReturningSeries,
  ].includes(status);
};
